// extracted by mini-css-extract-plugin
module.exports = {"mm100_home2":"home2_mm100_home2__dM0Mn"};